import Box from '@mui/material/Box';
import { Button, Grid, Paper, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, useMediaQuery } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { useStore } from '../../../app/stores/store';
import CloseIcon from '@mui/icons-material/Close';
import { PartnerKobHoveds, Ta1AdminKobhoved } from '../../../app/models/partners';
import { adminUserStyles } from './adminUserStyles';

interface Propsaaa {
    partnerData: Ta1AdminKobhoved;
}
const style = (isMobile: boolean) => {
    return ({
        position: 'absolute' as 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: isMobile ? 400 : 360,
        // bgcolor: 'background.paper',
        bgcolor: '#DAE5F1',
        border: '2px solid #000',
        boxShadow: 24,
        p: 2,
        // height: isMobile ? 650 : 800,
    })
};
const T1aPartnerModal = ({ partnerData }: Propsaaa) => {

    const { modalStore} = useStore();
    const { closeModal } = modalStore;
   

    const matches = useMediaQuery('(min-width:900px)');

    const closeModalHandler = () => {        
        closeModal();
    }

    if (!partnerData)
        return null;

    return (
        <Box sx={style(matches)}>
            <Typography variant='h6' textAlign='center'>{partnerData.partnerName}</Typography>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <TableContainer component={Paper}>
                        <Table size="small" aria-label="a dense table" >
                            <TableBody>
                                <TableRow sx={{ bgcolor: '#478ac92e' }}>
                                    <TableCell align="left" sx={adminUserStyles.tableCellStyle}>
                                        Partner: {partnerData.partnerName}
                                    </TableCell>
                                    <TableCell align="left" sx={adminUserStyles.tableCellStyle}>
                                        Number:  {partnerData.partnerNo}
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                            <TableBody>
                                <TableRow sx={{ bgcolor: '#478ac92e' }}>
                                    <TableCell align="left" sx={adminUserStyles.tableCellStyle}>
                                        Reseller: {partnerData.resellerName}
                                    </TableCell>
                                    <TableCell align="left" sx={adminUserStyles.tableCellStyle}>
                                        Number:   {partnerData.resellerNo}
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                            <TableBody>
                                <TableRow sx={{ bgcolor: '#478ac92e' }}>
                                    <TableCell align="left" sx={adminUserStyles.tableCellStyle}>
                                        Customer:   {partnerData.customerName}
                                    </TableCell>
                                    <TableCell align="left" sx={adminUserStyles.tableCellStyle}>
                                        Number:   {partnerData.customerNo}
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                        {partnerData.partnerKobHoveds.length > 0 &&
                            <Table>
                                <TableHead key={'tableKey'}>
                                    <TableRow>
                                        <TableCell align="left" sx={adminUserStyles.tableCellStyle}>Name</TableCell>
                                        <TableCell align="left" sx={adminUserStyles.tableCellStyle}>Role</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {partnerData.partnerKobHoveds.map((p: PartnerKobHoveds, index) =>
                                        <TableRow sx={{ bgcolor: '#478ac92e' }}
                                            key={index}
                                        >
                                            <TableCell align="left" sx={adminUserStyles.tableCellStyle}>
                                                {p.name}
                                            </TableCell>
                                            <TableCell align="left" sx={adminUserStyles.tableCellStyle}>
                                                {p.role}
                                            </TableCell>
                                        </TableRow>
                                    )}
                                </TableBody>
                            </Table>
                        }
                    </TableContainer>
                    <Stack
                        direction="row"
                        justifyContent="center"
                        alignItems="center"
                        spacing={2}
                        pt={2}
                    >
                        <Button size={matches ? "medium" : "small"} variant="contained" onClick={closeModalHandler}
                            startIcon={<CloseIcon />}>Close</Button>
                    </Stack>
                </Grid>
            </Grid>
        </Box>
    )
}
export default observer(T1aPartnerModal);